import {useContext, useEffect, useState} from "react";
import {speech} from "../../../utilis/speech";
import {AppContext} from "../../../reducer/contexts";
import {actionTypes} from "../../../reducer/actionTypes";
import ChatBoxPatient from "./ChatBoxPatient";
import ChatBoxDoctor from "./ChatBoxDoctor";
import {chatTimeout} from "../../../utilis/common";
import _ from "lodash";

const ChatBox = (props) => {
    const {dispatch} = useContext(AppContext);
    const [isLoaded, setIsLoaded] = useState(false);
    const currentSpeech = speech[props.subject][props.index];

    useEffect(() => {
        let prevSpeech;
        for (const speechKey in speech) {
            prevSpeech = speech[speechKey].filter(chat => _.isEqual(chat.next, {
                subject: props.subject,
                index: props.index
            }));

            if (prevSpeech.length) {
                break;
            }
        }

        prevSpeech = prevSpeech[0];

        let charCount = 0;
        if (typeof prevSpeech?.text.props.children === "string") {
            charCount = prevSpeech.text.props.children.length;
        } else {
            prevSpeech?.text.props.children.forEach(text => {
                if (typeof text === "string") {
                    charCount += text.length;
                }
            });
        }

        const timeout = charCount < 150 || currentSpeech.type === "question" ? chatTimeout : chatTimeout + 1000;

        setTimeout(() => {
            setIsLoaded(true);

            if (currentSpeech.next) {
                const nextSpeech = speech[currentSpeech.next.subject][currentSpeech.next.index];

                if (nextSpeech?.type === "question") {
                    let index = currentSpeech.next.index;
                    while (speech.doctor[index].type === "question") {
                        dispatch({
                            type: actionTypes.ADD_MESSAGE_TO_CHAT,
                            payload: {
                                subject: "doctor",
                                index
                            }
                        });

                        if (speech.doctor[index].questionEnd) {
                            break;
                        }

                        index++;
                    }
                } else if (nextSpeech?.type !== "answer") {
                    dispatch({
                        type: actionTypes.ADD_MESSAGE_TO_CHAT,
                        payload: {
                            subject: currentSpeech.next.subject,
                            index: currentSpeech.next.index
                        }
                    });
                }
            } else {
                dispatch({type: actionTypes.START_STOP_PLAYING});
            }
        }, timeout);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {props.subject === "patient" &&
                <ChatBoxPatient isLoaded={isLoaded} currentSpeech={currentSpeech} index={props.index}/>}
            {props.subject === "doctor" &&
                <ChatBoxDoctor isLoaded={isLoaded} currentSpeech={currentSpeech} index={props.index}/>}
        </>
    );
}

export default ChatBox;
